import React, { useEffect, useState } from 'react'
import apiRequest from '../../../lib/apiRequest';
import "./MasterPendingColonies.scss"
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../../components/showtoast/ToastContext';
import { consumePending } from '../../../lib/transferObjectsStore';

function MasterPendingColonies() {

    const { showToast } = useToast();

    const navigate=useNavigate();

    const [loading, setLoading] = useState(false);
    const [error,setError]=useState(null);
    const [pendingData,setPendingData]=useState(null)    
    const pendingCities = pendingData?.pendingcities ?? [];
    const pendingColonies = pendingData?.pendingcolonies ?? [];
    

    // after user is back in this comp
    useEffect(() => {

        const result = consumePending("result");
        console.log("result",result)
        // type can be city or colony, 
        // as its been send back from 2 pages

          if (result) {
            if (result.action=='approved'){
              alert("approved")
            }
            else if (result.action=='rejected'){
              alert("rejected")
            }
          }
      }, []);



     const fetchPending = async () => {
      try {
        setLoading(true);
        // const response = await apiRequest.get("/masters/pending");
          const response = await apiRequest.get("/masters/pending", {
        params: {
            foradmin: 1
        }
        });

        setLoading(false);
        return response.data;
      } catch (error) {
        console.error("Fetching pending data failed:", error);
        setLoading(false);
        throw error;
      }
    };
    
      const LoadPendingData= async()=>{
        try {
          const data=await fetchPending();
          setPendingData(data);
        } catch (error) {
          setError(error)
          console.error("Error fetching pending data:", error);      
    
        }
      }
    
    useEffect(() => {
    
      LoadPendingData();
    
    }, []);
    

    const handleApproveColony = (colony) => {
      // Handle colony approval here
        // alert("adfasd")

          console.log("Approving colony:", colony);
      // alert("ddd")

      if ( (colony.cityid==null)) {
        // alert("Please approve city first");
        showToast("Please approve city first","alert")
        return;
      }

        try {
                navigate('/admin/colony/0', {
                    state: { 
                        mode: 0, 
                        colonyid: 0 ,
                        fromPending:true,
                        pendingData:colony
                    }
                });    

        } catch (error) {
            console.log(error);
        }
    };

    const handleApproveCity = (city) => {
          console.log("Approving city:", city);
        try {
                navigate('/admin/cities', {
                    state: { 
                        mode: 0, 
                        cityid: 0 ,
                        fromPending:true,
                        pendingData:city
                    }
                });    

        } catch (error) {
            console.log(error);
        }
    };


const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "approved":
      return "green";
    case "rejected":
      return "red";
    case "pending":
      return "orange";
    default:
      return "black";
  }
};


    
  if (loading) return <p>Loading pending requests...</p>;
  if (error) return <p>{error.message}</p>;



    return (
        <div className="pendingTab">


              {pendingCities.length >0 && (
              <>
                <h4>Pending Cities</h4>
                <ul className="scrollable grid" >
                  {pendingCities.map((city) => (
                    <li   
                      key={city.id}
                        onClick={()=>handleApproveCity(city)}
                        style={{ cursor: "pointer" }}
                    >
                      <strong>{city.cityname}</strong>
                      <br />
                      Status: 
                      <span className={`status ${city.status.toLowerCase()}`}>
                          {city.status}
                      </span>
                      <br />
                      Requested on: {city.request_date}
                    </li>
                  ))}
                </ul>
              </>
              )}

              {pendingColonies.length >0 && (
                 
                <>
                <h4>Pending Colonies</h4>
                <ul className="scrollable grid">
                  {pendingColonies.map((colony) => (
                    <li 
                        key={colony.id}
                        onClick={()=>handleApproveColony(colony)}
                        style={{ cursor: "pointer" }}
                    >
                      <strong>{colony.colonyname}</strong>
                      <br />
                      City: {colony.cityname}
                      <br />
                      New City: {colony.newcityname}
                      <br />
                      {/* Status: {colony.status} */}
                      Status: 
                      <span className={`status ${colony.status.toLowerCase()}`}>
                          {colony.status}
                      </span>


                      <br />
                      Requested on: {colony.request_date}
                    </li>
                  ))}
                </ul>
                </>
              )}




        </div>

  )
}

export default MasterPendingColonies
